module.exports = __webpack_public_path__ + "files/1431a2c21e665c053273e4922f60e4a3.png";